import { useEffect } from 'react'
import useCachedDirections from 'components/configured-service/tabs/MapRoutingTab/hooks/useCachedDirections'

/**
 * Thin wrapper around `useCachedDirections` that fetches a Routes-API polyline
 * for the given stops and returns the encoded path string. Rendering is left to
 * `CachedDirectionsDeckLayer` (WebGL, zoom-aware) or a plain Google Polyline
 * (DOM fallback) — both of which need to live inside an `<APIProvider>`.
 */
const useCachedDirectionsLayers = ({ stops }) => {
  const { getDirections, encodedPath } = useCachedDirections()

  useEffect(() => {
    if (Array.isArray(stops) && stops.length >= 2) {
      getDirections(stops)
    }
  }, [stops, getDirections])

  return { encodedPath }
}

export default useCachedDirectionsLayers
